import DailyGeneratedReportPage from "../../../components/reports/DailyGeneratedReportPage";
import OrganizationTicketsPerService from "../../../components/organization/reports/daily/OrganizationTicketsPerService";
import {
  TICKETS_PER_SERVICE_COLUMN_DEFINITIONS,
} from "../../../store/renderConfig";

const DailyOrganizationTicketsPerService = ({
  reportIndex = "**REPORT_INDEX**",
}) => (
  <DailyGeneratedReportPage
    columnDefinitions={TICKETS_PER_SERVICE_COLUMN_DEFINITIONS}
    descriptionKey="TicketsPerService"
    title={`${reportIndex}. Tickets Per Service`}
  >
    {({ data, renderConfig }) => (
      <OrganizationTicketsPerService reportIndex={reportIndex} data={data} renderConfig={renderConfig} />
    )}
  </DailyGeneratedReportPage>
);

export default DailyOrganizationTicketsPerService;
